import { defineStore } from "pinia";
import { ref } from "vue";

export const useAiBannerStore = defineStore("aiBanner", () => {
  const hasNewContent = ref<boolean>(false);
  const shouldOpenDrawer = ref<boolean>(false);
  const lastGeneratedBannerUrl = ref<string | null>(null);

  const requestOpenDrawer = () => {
    shouldOpenDrawer.value = true;
  };

  const clearOpenDrawerRequest = () => {
    shouldOpenDrawer.value = false;
  };

  const setLastGeneratedBannerUrl = (url: string) => {
    lastGeneratedBannerUrl.value = url;
  };

  const clearLastGeneratedBannerUrl = () => {
    lastGeneratedBannerUrl.value = null;
  };

  return {
    hasNewContent,
    shouldOpenDrawer,
    lastGeneratedBannerUrl,
    requestOpenDrawer,
    clearOpenDrawerRequest,
    setLastGeneratedBannerUrl,
    clearLastGeneratedBannerUrl,
  };
});
